import React from 'react';
import { Button, Layout, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useOutletContext } from 'react-router-dom';
import logo from '../../assets/prism-logo.png';

const { Header } = Layout;

type OutletContextType = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  // Add any other properties your context provides
};

function AppHeader({
  headerActions,
  extraActions,
  title,
}: {
  headerActions?: React.ReactNode;
  extraActions?: React.ReactNode;
  title: string;
}) {
  const { collapsed, setCollapsed } = useOutletContext<OutletContextType>();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <>
      <Header style={{ padding: 0, background: colorBgContainer }} className="flex items-center justify-between px-4">
        {/* Left: collapse button */}
        <div className="flex items-center gap-2">
          <Button
            type="text"
            className="ms-2"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
            }}
          />
          <span className="text-gray-750 font-bold">{title}</span>
          {headerActions}
        </div>
        {/* Right: image and text */}
        <div className="flex flex-row items-center gap-2">
          <div className="me-4">{extraActions || null}</div>
          <div className="flex flex-col items-end mr-6 mt-1">
            <img src={logo} alt="Logo" />
            <span className="text-xs font-semibold text-gray-400" style={{ width: '75%', fontSize: '8px', textAlign: 'right' }}>
              BY SPHERE GLOBAL
            </span>
          </div>
        </div>
      </Header>
    </>
  );
}

export default AppHeader;
